'use strict';

$(document).ready(function () {
    $('.itb-text-inner').matchHeight();

    $(window).smartresize(function () {
        $('.itb-text-inner').matchHeight();
    });
});
